import React from "react";

const WorkProcessFour = () => {
  return (
    <>
      {/*==================== Work Process Three start ====================*/}
      <div
        className="work-process-area bg-position-right pd-top-120 pd-bottom-90"
        style={{ backgroundImage: 'url("./assets/img/bg/16.png")' }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="section-title text-center pb-5">
                <h6 className="sub-title-sky-blue">优化流程，释放潜能</h6>
                <h2 className="title">
                  精心设计的工作流程确保高效、无缝的项目管理
                </h2>
              </div>
            </div>
          </div>
          <div className="work-process-area-inner-2">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="single-work-process-inner style-2 text-center">
                  <img
                    className="line-img"
                    src="assets/img/about/29.png"
                    alt="img"
                  />
                  <div className="thumb mb-3">
                    <img src="assets/img/icon/36.svg" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="mb-3">评估</h5>
                    <p className="content">
                      在我们的工作流程中，一切都始于评估。我们通过仔细的分析和了解，确保我们理解了目标、挑战和机会。这个环节使我们能够明智地决策，为下一步的规划做好充分的准备。
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="single-work-process-inner style-2 text-center">
                  <img
                    className="line-img"
                    src="assets/img/about/30.png"
                    alt="img"
                  />
                  <div className="thumb mb-3">
                    <img src="assets/img/icon/37.svg" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="mb-3">实施规划</h5>
                    <p className="content">
                      一旦评估完成，我们便开始制定实施规划。这个步骤包括了详细的计划、资源分配以及时间表安排。我们追求高效、无缝的执行，确保项目和计划按照计划顺利推进。
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="single-work-process-inner style-2 text-center">
                  <img
                    className="line-img"
                    src="assets/img/about/29.png"
                    alt="img"
                  />
                  <div className="thumb mb-3">
                    <img src="assets/img/icon/38.svg" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="mb-3">能力提升</h5>
                    <p className="content">
                      我们深知，在不断变化的环境中，保持竞争力至关重要。因此，我们不断投资于能力提升。我们的团队接受持续培训，拥有最新的技能和知识，以适应市场的要求。
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="single-work-process-inner style-2 text-center">
                  <img
                    className="line-img"
                    src="assets/img/about/30.png"
                    alt="img"
                  />
                  <div className="thumb mb-3">
                    <img src="assets/img/icon/39.svg" alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="mb-3">创新</h5>
                    <p className="content">
                      创新是我们的精髓。我们鼓励创新精神，鼓励新的思想和方法，以推动持续的改进。通过创新，我们不仅适应变化，还引领变革，创造出新的机会。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ==================== Work Process Three end ====================*/}
    </>
  );
};

export default WorkProcessFour;
